<template>
    <div>
        <!-- banner -->
        <div>
            <el-carousel trigger="click" height="100vh"  style="position:relative;" v-if="width >= 1200">
                <el-carousel-item v-for="item in imgList" style="cursor: pointer" :key="item" @click.native="$router.push(item.routerPush)">
                    <img style="width: 100%;height: 100%;object-fit: cover"  class="img" :src="imgserver + item.picture" alt="">
                    <div class="bannerTitle">
                        <p style=" font-size: 100px !important;"> {{ item.mainTitle }} </p>
                    </div>
                </el-carousel-item>
            </el-carousel>
            <el-carousel trigger="click" height="300px"  style="position:relative;" v-if="width < 768" ref="slideCarousel">
                <el-carousel-item v-for="item in imgList" tyle="cursor: pointer" :key="item" @click.native="$router.push(item.routerPush)" >
                    <img style="width: 100%;height: 100%;object-fit: cover"  class="img" :src="imgserver + item.picture" alt="">
                    <div class="bannerTitle">
                        <p > {{ item.mainTitle }} </p>
                    </div>
                </el-carousel-item>
            </el-carousel>
            <!-- <el-carousel trigger="click" height="300px"  style="width:100%;position: relative;" v-if="width <= 768">
                <el-carousel-item v-for="item in imgLists" :key="item" >
                    <img class="img" :src="item.img" alt="">
                    <p class="bannerTitle">心理装备的探路者</p>
                </el-carousel-item>
            </el-carousel> -->
        </div>
        <!-- 导航栏 -->
        <div class="nav" v-if="width >= 1200">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane label="心闻资讯" name="1"></el-tab-pane>
                        <el-tab-pane label="服务体系" name="2"></el-tab-pane>
                        <el-tab-pane label="产业体系" name="3"></el-tab-pane>
                        <el-tab-pane label="业务体系" name="4"></el-tab-pane>
                </el-tabs>
        </div>
        <div class="nav" v-if="width <= 768">
                <el-tabs v-model="activeNames" type="card" @tab-click="handleClick2">
                        <el-tab-pane label="心闻资讯" name="1"></el-tab-pane>
                        <el-tab-pane label="服务体系" name="2"></el-tab-pane>
                        <el-tab-pane label="产业体系" name="3"></el-tab-pane>
                        <el-tab-pane label="业务体系" name="4"></el-tab-pane>
                </el-tabs>
        </div>
        <!-- 公司简介 -->
        <!-- pc -->
        <div class="body" v-if="width >= 1200">
              <!-- 新闻动态 -->
              <div class="news" id="news">
                <div class="newTitle">心闻资讯</div>
                <div class="oneline">
                    <!-- <div class="long">
                        <img src="../assets/img/newone.png" alt="">
                        <span>国家、省、市各级领导参观交流</span>
                    </div> -->
                    <div style="cursor: pointer;" :class="index == 0 ? 'long' : 'short'" v-for="(item,index) in newsList" :key="index" @click="handleClickDownload(index,item)">
                        <img  style="border-radius: 10px" :src="imgserver + item.picture" alt="">
                        <span>{{ item.mainTitle }}</span>
                    </div>
                </div>
              </div>
             <!-- 公司简介 -->
             <div class="profile" id="profile">
                <div class="profileTitle">公司简介</div>
<!--                <p class="profileContent" style="text-indent:2em;">{{ companyProfile.subTitle.substr(0,64) }}<span>{{ companyProfile.subTitle.substr(64) }}</span></p>-->
               <p style="white-space:pre;" class="profileContent ql-editor ql-container ql-snow" v-html="companyProfile.subTitle"></p>

                <div style="width: 1158px;margin: 0 auto; padding: 0 30px;box-sizing:border-box"><el-button round @click="companyClick(1)">了解更多</el-button></div>
                <div class="profileBoxs" id="one">

                    <div class="boxs">
                        <div class="ons">
                            <div style="font-weight: 800">{{ serviceSystem.mainTitle }}</div>
<!--                            <p style="text-indent:2em;">{{  }}</p>-->
                            <p style="height: 46%" class="ql-editor ql-container ql-snow" v-html="serviceSystem.subTitle"></p>
                            <el-button round @click="companyClick(2)">了解更多</el-button>
                        </div>

                    </div>
                    <img style="border-radius: 10px" :src="imgserver + serviceSystem.picture" alt="">
                </div>
                <div class="profileBox" id="two">
                    <img style="border-radius: 10px" :src="imgserver + industrialSystem.picture" alt="">
                    <div class="box">
                        <div class="on">
                            <div style="font-weight: 800">{{ industrialSystem.mainTitle }}</div>
                          <p style="height: 30%" class="ql-editor ql-container ql-snow" v-html="industrialSystem.subTitle"></p>
                            <el-button round @click="companyClick(3)">了解更多</el-button>
                        </div>

                    </div>
                </div>
                <div class="profileBoxs" id="three">

                    <div class="boxs">
                        <div class="ons">
                            <div style="font-weight: 800">{{ businessSystem.mainTitle }}</div>
                          <p style="height: 46%" class="ql-editor ql-container ql-snow" v-html="businessSystem.subTitle"></p>
                            <el-button round @click="companyClick(4)">了解更多</el-button>
                        </div>

                    </div>
                    <img style="border-radius: 10px" :src="imgserver + businessSystem.picture" alt="">
                </div>
            </div>
        </div>
        <!-- 移动 -->

        <div class="body" v-if="width <= 768">
            <!-- 新闻咨询 -->
            <div class="news">
                <div class="etitle">心闻资讯</div>
                <el-carousel trigger="click" height="200px" style="width:100%;position: relative;border-radius:4px;" v-if="width <= 768">
                    <el-carousel-item v-for="(item,index) in newsList" :key="item">
                        <img style="border-radius: 10px" class="imgs"  @click="handleClickDownload(index,item)" :src="imgserver + item.picture" alt="">
                        <p class="ptitle">{{ item.mainTitle }}</p>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <!-- 服务体系 -->
            <div class="employ">
                <div class="box">
                    <div class="employtitle">{{ serviceSystem.mainTitle }}</div>
                  <p style="font-size: 12px !important;" class="ql-editor ql-container ql-snow" v-html="serviceSystem.subTitle"></p>
                    <el-button round @click="companyClick(2)" v-if="button">了解更多</el-button>
                    <img style="border-radius: 10px" :src="imgserver + serviceSystem.picture" alt="">
                </div>
                <div class="box">
                    <div class="employtitle">{{ industrialSystem.mainTitle }}</div>
                  <p style="font-size: 12px !important;" class="ql-editor ql-container ql-snow" v-html="industrialSystem.subTitle"></p>
                    <el-button round @click="companyClick(3)" v-if="button">了解更多</el-button>
                    <img  style="border-radius: 10px" :src="imgserver + industrialSystem.picture" alt="">
                </div>
                <div class="box">
                    <div class="employtitle">{{ businessSystem.mainTitle }}</div>
                  <p style="font-size: 12px !important;" class="ql-editor ql-container ql-snow ql-size-12px" v-html="businessSystem.subTitle"></p>
                    <el-button round @click="companyClick(4)" v-if="button">了解更多</el-button>
                    <img style="border-radius: 10px" :src="imgserver + businessSystem.picture" alt="">
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { getBanner,getIndex } from '../api/api'
export default {
    data () {
        return {
            activeName:"1",
            activeNames:'1',
            button:true,
            imgList:[],
            // newsList:[],
            newsList:[],
            companyProfile:{},
            width:document.documentElement.clientWidth,
            serviceSystem:{},
            industrialSystem:{},
            businessSystem:{},
            employList:[
                {
                    title:"服务体系",
                    content:"瑞阳心语致力于心理学应用领域和社会心理服务领域的实践，经过多年总结已形成“社区心理服务、学校心理服务、EAP心理服务、社会工作和公益服务”四大服务体系，可以满足各行各业对心理健康服务的需求。",
                    src:require('../assets/move/profile1.png')
                },
                {
                    title:"产业体系",
                    content:"瑞阳心语致力于心理科技和心理健康产业的融合发展，以“心智谷”为突破点，搭建心理服务产业发展平台，打造心理服务“理论研究、实践应用、产业发展”三个新高地。",
                    src:require('../assets/move/profile2.png')
                },
                {
                    title:"业务体系",
                    content:"瑞阳心语致力于全生命周期心理健康服务的资源整合，形成“天网、地网、人网、和网”四大业务体系，推动心理智慧云平台建设、心理服务物理空间建设、人才培养与人才选拔、心理专业服务领域的发展。",
                    src:require('../assets/move/profile3.png')
                }
            ],
        }
    },
    mounted () {
        // 滑动切换

        // let that = this
      window.onresize = () => {
        return (() => {
          this.width = document.documentElement.clientWidth // 宽
        // console.log(that.width,'that.width');
        })()
      }
        this.onload()
        this.slideBanner()
    },
    methods: {
        slideBanner() {
            //选中的轮播图
            var box = document.querySelector('.el-carousel__container');
            var startPointX = 0
            var stopPointX = 0
            //重置坐标
            var resetPoint = function () {
                startPointX = 0
                stopPointX = 0
            }
            //手指按下
            box.addEventListener("touchstart", function (e) {
                //手指点击位置的X坐标
                startPointX = e.changedTouches[0].pageX
            });
            //手指滑动
            box.addEventListener("touchmove", function (e) {
                //手指滑动后终点位置X的坐标
                stopPointX = e.changedTouches[0].pageX
            });
            //当手指抬起的时候，判断图片滚动离左右的距离
            let that = this
            box.addEventListener("touchend", function (e) {
                if (stopPointX == 0 || startPointX - stopPointX == 0) {
                resetPoint()
                return
                }
                if (startPointX - stopPointX > 0) {
                resetPoint()
                that.$refs.slideCarousel.next()
                return
                }
                if (startPointX - stopPointX < 0) {
                resetPoint()
                that.$refs.slideCarousel.prev()
                return
                }
            });
        },
      handleClickDownload(index,item){
        console.log(index,'xin');
        if(index===0){
          this.$router.push({
            path:'/download',
            query:{
              index:'2',
            }
          })
        }else if (index===1) {
          this.$router.push({
            path:'/download',
            query:{
              index:'5',
            }
          })
        }else if (index===2) {
          this.$router.push({
            path:'/download',
            query:{
              index:'3',
            }
          })
        }else if (index===3) {
          this.$router.push({
            path:'/download',
            query:{
              index:'4',
            }
          })
        }else if (index===4) {
          this.$router.push({
            path:'/download',
            query:{
              index:'1',
            }
          })
        }

      },
        handleClick(tab,event){
            if(tab.name == 1) {
                document.getElementById("profiles").scrollIntoView({ behavior: 'smooth' })
            } else if (tab.name == 2) {
                document.getElementById("profile").scrollIntoView({ behavior: 'smooth' })
            } else if (tab.name == 3){
                document.getElementById("one").scrollIntoView({ behavior: 'smooth' })
            } else if (tab.name == 4){
                document.getElementById("two").scrollIntoView({ behavior: 'smooth' })
            }
        },
        handleClick2(tab,event){
            if(tab.name == 1) {
                document.getElementById("profiles").scrollIntoView({ behavior: 'smooth' })
            } else if (tab.name == 2) {
                document.getElementById("employ").scrollIntoView({ behavior: 'smooth' })
            }
            // else if (tab.name == 3){
            //     document.getElementById("one").scrollIntoView({ behavior: 'smooth' })
            // } else if (tab.name == 4){
            //     document.getElementById("two").scrollIntoView({ behavior: 'smooth' })
            // }
        },
        onload(){
            getBanner({bannerType:1}).then(res => {
              res.data.data.forEach(item => {
                if(item.mainTitle=='心理科技的探索者'){
                  item.routerPush = '/goin?activeName=1'
                } else if (item.mainTitle=='心理装备的探路者') {
                  item.routerPush = '/mentally'
                } else if (item.mainTitle=='社会心理服务的实践者') {
                  item.routerPush = '/product?activeName=1'
                } else if (item.mainTitle=='学校心理服务的耕耘者') {
                  item.routerPush = '/product?activeName=2'
                } else if (item.mainTitle=='EAP服务的创新者') {
                  item.routerPush = '/product?activeName=3'
                } else if(item.mainTitle=='标准体系的制定者') {
                  item.routerPush = '/case?activeName=2'
                } else if(item.mainTitle=='心理学博鳌论坛') {
                  item.routerPush = '/goin?activeName=3'
                }

              })
                this.imgList = res.data.data

            })
            getIndex().then(res => {
                this.newsList = res.data.data.newsList
                this.companyProfile = res.data.data.companyProfile
            //    this.companyProfile.subTitle =  this.companyProfile.subTitle.replace
                this.serviceSystem = res.data.data.serviceSystem
                this.industrialSystem = res.data.data.industrialSystem
                this.businessSystem = res.data.data.businessSystem
            })
       },
        // 了解更多
        more(){
            this.hide = true
            this.button = false
        },
        companyClick(i){
           if(i == 1) {
            this.$router.push({
                path:'news',
            })
           } else if(i == 2){
            this.$router.push({
                path:'product',
            })
           } else if(i == 3){
            this.$router.push({
                path:'case',
            })
           } else {
            this.$router.push({
                path:'goin',
            })
           }
        },
    }

}
</script>


<style scoped>
.ql-editor .ql-container .ql-snow .ql-size-16px{
  font-size: 12px !important;
}
</style>

<style lang="scss" scoped>
@import url('../assets/font/font.css');
* {
        margin: 0;
        padding: 0;
        font-family: Microsoft YaHei;
  font-size: 16px;
    }
    .img{
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
    }

    ::v-deep .el-carousel__button{
        width: 65px;
        height: 15px;
        border-radius: 35px;
    }
    ::v-deep .el-tabs--card {
        border: 0 !important;
    }
    ::v-deep .el-tabs__item .is-active{
        color: #34A59A !important;
    }
    ::v-deep .el-tabs__item{
        color: #666666 !important;
    }
    ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
        background-color: #fff !important;
        color: #34A59A !important;
        border-bottom-color: transparent !important;
    }
   ::v-deep .el-tabs--card>.el-tabs__header{
        border-bottom: none !important;
   }
   ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav{
        border: none;
   }
   ::v-deep .el-carousel__indicators--horizontal{
        bottom: 10%;
    }
    ::v-deep .el-tabs__nav-scroll {
            width: 1440px;
            margin: 0 auto;
        }
@media (min-width:1200px) {
    .body{
        width: 1440px;
        margin: 0 auto;
    }
    .bannerTitle{
        position: absolute;
        top: 45%;
        color: #fff;
        font-size: 100px !important;
        width: 100%;
        // margin: 0 auto;
        // margin-left: 240px;
        // font-weight: normal;
        // font-feature-settings: "kern" on;
        p{
            width: 1440px;
            margin: 0 auto;
        }
    }
    .nav{
        width: 100%;
        // padding: 20px 0 0 0;
        height: 50px;
        line-height: 50px;
        box-shadow: 0px 4px 10px 0px #E9F5F9;
        margin-bottom: 20px;
        box-sizing: border-box;
    }
    ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item{
        border: none !important;
        background-color: #fff !important;
        font-size: 18px;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0em;
    }

   .profiles{
        width: 100%;
        box-sizing: border-box;
        padding: 40px 0;
        // position: relative;
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
        img{
            width: 45%;
            // height: 80%;
        }
        .right{
            // position: absolute;
            // left: 38%;
            // top: 11%;
            // width: 52.5%;
            // height: 75%;
            // background-color: #fff;
            // display: inline-block;
            // box-sizing: border-box;
            // padding: 30px 30px 30px 50px;
            // display: flex;
            // flex-direction: column;
            // justify-content: center;
            .profileTitle{
                font-size: 30px;
                color: #333333;
                font-weight: 700px;
            }
            .titleEnglish{
                font-size: 18px;
                line-height: 15px;
                color: #000000;
                margin-top: 10px;
                margin-bottom: 40px;
                .row{
                    display: inline-block;
                    width: 15px;
                    height: 15px;
                    border-radius: 50%;
                    border: 3px solid #3DCDD0;
                    margin-right: 5px;
                }
            }
            p{
                font-size: 14px;
                letter-spacing: 0em;
                color: #3D3D3D;
                // margin-top: 20px;
            }
            .el-button.is-round{
                border-color: #3DCDD0;
                color: #3DCDD0;
                // margin-top: 50px;
                // width: 15%;
            }
        }

    }
   .news{
    width: 100%;
    // height: 100vh;
    padding:20px 0 30px 0;
    box-sizing: border-box;
    .newTitle{
        font-size: 30px;
        font-weight: 700;
        line-height: 50px;
        letter-spacing: 0px;
        color: #333333;
        margin-bottom: 30px;
        text-align: center;
    }
    .oneline{
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        font-size: 20px;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0em;
        color: #FFFFFF;

        .long{
            width: 66.5%;
            position: relative;

            span{
                position: absolute;
                bottom: 50px;
                left: 20px;
            }
            img{
                width: 100%;
                height: 350px;
                border-radius: 10px;
            }
        }
        .short{
            width: 33%;
            position: relative;

            span{
                position: absolute;
                bottom: 50px;
                left: 20px;
            }
            img{
                width: 100%;
                height: 350px;
            }

        }
    }
   }
  .profile {
        width: 100%;
        padding: 60px 0;
        box-sizing: border-box;
        .el-button.is-round{
                border-color: #3DCDD0;
                color: #7fd7d8;
                // margin-top: 50px;
                width: 100px;
                background-color: #fff;
                // position: absolute;
                // bottom: 70px;
                // left: 46%;
            }
        .profileTitle{
            text-align: center;
            font-size: 30px;
            font-weight: 700;
            line-height: 50px;
            letter-spacing: 0px;
            color: #333333;
        }
        .profileContent{
            width: 1158px;
            padding: 30px;
            margin: 0 auto;
            box-sizing: border-box;

            color: #333333;
            span{
                font-size: 16px;
                font-weight: normal;
                line-height: 30px;
                color: #666666;
            }
        }

        .profileBox{
            width: 100%;
            // height: 35vh;
            height: 440px;
            background: #EEF5F6;
            z-index: -1;
            // position: relative;
            display: flex;
            justify-content: space-around;
            margin-top: 80px;
            // .el-button.is-round{
            //     border-color: #3DCDD0;
            //     color: #3DCDD0;
            //     margin-top: 50px;
            //     width: 100px;
            //     background-color: #EEF5F6;
            //     // position: absolute;
            //     // bottom: 70px;
            //     // left: 60px;
            // }
            img{
                // width: 40%;
                // height: 100%;
                width: 720px;
                height: 440px;
                // position: absolute;
                // top: -30px;
                // right: 0;
                z-index: 100;
                margin-top: -50px;
                margin-left: -30px;
            }
            .box{
                // width: 97%;
                // height: 100%;
                // border-radius: 10px;

                // position: absolute;
                // left: 0;
                .on{
                    width: 500px;
                    height: 100%;
                    // position: absolute;
                    // // left: 60px;
                    display: flex;
                    flex-direction: column;
                    justify-content: start;
                    // box-sizing: border-box;
                    // padding-top: 30px;
                    div{
                        font-size: 28px;
                        font-weight: 500;
                        line-height: 50px;
                        letter-spacing: 0em;
                        color: #333333;
                        margin-top: 50px;
                    }
                    p{
                        font-size: 16px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;
                        color: #666666;
                        margin-top: 50px;
                    }
                    .el-button.is-round{
                        background-color: transparent !important;
                        margin-top: 50px;
                    }
                }
            }

        }
        .profileBoxs{
            width: 100%;
            // height: 35vh;
            height: 440px;
            background: #EEF5F6;
            z-index: -1;
            // position: relative;
            display: flex;
            justify-content: space-around;
            margin-top: 80px;
            // .el-button.is-round{
            //     border-color: #3DCDD0;
            //     color: #3DCDD0;
            //     margin-top: 50px;
            //     width: 100px;
            //     background-color: #EEF5F6;
            //     // position: absolute;
            //     // bottom: 70px;
            //     // left: 60px;
            // }
            img{
                // width: 40%;
                // height: 100%;
                width: 720px;
                height: 440px;
                // position: absolute;
                // top: -30px;
                // right: 0;
                z-index: 100;
                margin-top: -50px;
                margin-right: -100px;
            }
            .boxs{
                // width: 97%;
                // height: 100%;
                // border-radius: 10px;

                // position: absolute;
                // left: 0;
                .ons{
                    width: 500px;
                    height: 100%;
                    // position: absolute;
                    // // left: 60px;
                    display: flex;
                    flex-direction: column;
                    justify-content: start;
                    // box-sizing: border-box;
                    // padding-top: 30px;
                    div{
                        font-size: 28px;
                        font-weight: 500;
                        line-height: 50px;
                        letter-spacing: 0em;
                        color: #333333;
                        margin-top: 50px;
                    }
                    p{
                        letter-spacing: 0em;
                        color: #666666;
                        margin-top: 50px;
                    }
                    .el-button.is-round{
                        background-color: transparent !important;
                        //margin-top: 50px;
                    }
                }
            }

        }
   }
   .honors{
        width: 1206px;
        margin: 0 auto;
        box-sizing: border-box;
        // height: 75vh;
        padding: 50px 0;
        text-align: center;
        .honorsTitle{
            font-weight: 500;
            line-height: 50px;
            letter-spacing: 0px;
            color: #333333;
            font-size: 30px;
        }
        .honerImg{
            width: 100%;
            display: flex;
            justify-content: space-between;
            .imgBox{
                width: 30%;
                img{
                    width:100%;
                    margin: 30px 0;
                }
                p{
                    font-size: 24px;
                    font-weight: normal;
                    line-height: normal;
                    letter-spacing: 0em;
                    color: #3D3D3D;
                }
            }
        }
    }

}
@media(max-width:1200px){
    ::v-deep .el-carousel__indicators--horizontal {
        bottom: 10%;
        width: 100% !important;
        text-align: center !important;
    }
    .nav{
        width: 100%;
        // padding: 20px 0 0 0;
        height: 50px;
        line-height: 50px !important;
        box-shadow: 0px 4px 10px 0px #E9F5F9;
        margin-bottom: 20px;
        box-sizing: border-box;
    }
    ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item{
        border: none !important;
        background-color: #fff !important;
        font-size: 14px;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0em;
        height: 30px;
    }
    ::v-deep .el-tabs__nav-scroll {
        width: 100%;
        margin: 0 auto;
    }
    .bannerTitle{
        position: absolute;
        top: 45%;
        left: 20px;
        font-size: 24px;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: 0px;
        color: #FFFFFF;
    }
    ::v-deep .el-carousel__button{
        width: 25px;
        height: 4px;
        border-radius: 4px;
    }
    .etitle{
        font-size: 22px;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0em;
        color: #333333;
        text-align: center;
        margin-bottom: 20px;
    }
    .nav{
        width: 100%;
        // padding: 20px 0 0 0;
        box-shadow: 0px 4px 10px 0px #E9F5F9;
        margin-bottom: 20px;
        box-sizing: border-box;
        line-height: 20px;
        // height: 46px;
    }
    ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item{
        border: none !important;
        background-color: #fff !important;
        font-size: 14px;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0em;
        height: 20px;
    }
    ::v-deep .el-tabs--card>.el-tabs__header{
        border-bottom: none !important;
        line-height: 46px;
   }
   ::v-deep .el-tabs--card {
        border: 0 !important;
        height: 46px;
    }
    .profiles{
        width: 100%;
        box-sizing: border-box;
        padding: 10px 0;

        // display: flex;
        // flex-direction: column;
        // justify-content: center;
        img{
            width: 100%;

            // height: 80%;
        }
        .rightbox{
            position: relative;
            width: 100%;
            height: 400px;
        }
        .right{
            position: absolute;
            left: 20px;
            top: -15%;
            width: 90%;
            height: 450px;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, #FFFFFF 100%);
            box-shadow: 0px 4px 10px 0px #E9F5F9;
            box-sizing: border-box;
            padding: 20px;
            // text-align: center;
            p{
                font-size: 14px;
                letter-spacing: 0em;
                color: #333333;
                // margin-top: 20px;
            }
            .el-button.is-round{
                border-color: #3DCDD0;
                color: #3DCDD0;
                margin-top: 10px;
                width: 20%;
                padding: 5px;
                font-size: 12px;
            }
        }

    }
    .body{
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
    }
    .employ{
        width: 100%;
        margin-bottom: 20px;
        color: #fff;
        .box{
            width: 100%;
            height: 240px;
            margin-top: 20px;
            box-sizing: border-box;
            padding: 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            background-size: 100% 100%;
            position: relative;
            .el-button.is-round{
                border-color: #fff;
                color: #fff;
                margin-top: 10px;
                width: 20%;
                padding: 5px;
                font-size: 12px;
                background-color: transparent;

            }
            img{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: -1;
            }
            .employtitle{
                font-size: 14px;
                font-weight: 600;
            }
            p{
              margin-top: 8px;
                font-size: 12px !important;

            }
        }
    }
    .news{
        width: 100%;
        margin-bottom: 30px;
        height: 240px;
        ::v-deep .el-carousel__indicators--horizontal{
            bottom: 2%;
            width: 100%;
            text-align: center;
        }
        ::v-deep .el-carousel__button{
            width: 38px;
            height: 4px;
            border-radius: 4px;
            background: #3DCDD0;
        }
        .ptitle{
            position: absolute;
            bottom: 10%;
            z-index: 20;
            color: #fff;
            left: 20px;
            font-size: 16px;
        }
        .imgs{
            width: 100%;
            height: 80%;
        }
    }
}
</style>
